import React from 'react';
import { Warning2, TickCircle } from 'iconsax-react';

type Props = {
  row: { backgroundCheckCompleted?: boolean; onboardingComplete?: boolean };
  value?: any;
};

const CheckOrWarning = ({ row }: Props) => {
  const ok = !!(row?.backgroundCheckCompleted && row?.onboardingComplete);
  return ok ? (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <TickCircle color="#17926c" size={24} />
    </div>
  ) : (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Warning2 color="#fdb834" size={24} />
    </div>
  );
};

export default CheckOrWarning;
